<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.MGM活动排行榜") }}</span>
    </div>

      <!-- 筛选栏开始 -->
      <div class="grid-content content-margin search-style">
      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.MGM活动") }}</span>
          </td>
          <td>
            <el-select
              v-model="mgmID"
              :placeholder="$t('message.请选择MGM活动')"
              @change="refreshRank"
            >
              <el-option
                v-for="item in mgmList"
                :key="item.mgmid"
                :label="item.name"
                :value="item.mgmid"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
      </table>
            <!-- 筛选按钮开始 -->
            <div class="search-button"> 
            <div style="flex:0 0 80px;text-align:right"> </div>
            <div style="display:flex;">
              <el-button type="primary" @click="refresh" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini" icon="el-icon-search">检索</el-button>
              <el-button type="danger"  @click="clear" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini"  icon="el-icon-delete">清除</el-button>
            </div>
        </div>
            <!-- 筛选按钮结束 -->
      </div>
      <!-- 筛选栏结束 -->

    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="rankList"
        stripe
        border
        :height="tableHeight"
        style="width: 100%"
      >
        <!-- <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editTarget(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-edit"
                @click="editTarget(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  targetRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="rank"
          :label="$t('message.排名')"
          width="125"
        >
        </el-table-column>

        <el-table-column
          prop="nickame"
          :label="$t('message.昵称')"
          width="150"
        >
        </el-table-column>

        <el-table-column
          prop="score"
          :label="$t('message.邀请人数')"
          width="125"
        >
        </el-table-column>

        <el-table-column
          prop="mobile"
          :label="$t('message.手机')"
          width="125"
        >
        </el-table-column>

        <el-table-column prop="userID" label="UserID" width="250">
        </el-table-column>

        <el-table-column prop="openID" label="OpenID" width="250">
        </el-table-column>

        <el-table-column prop="unionID" label="UnionID" width="250">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
// 分页模块
import pagination from "@/components/pagination/pagination";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";

export default {
  name: "PointGainList",
  components: {
    pagination,
  },
  data() {
    return {
      tableHeight: 500,

      //mgm活动列表
      mgmList: [],
      rankList: [],
      mgmID: null,

      deleteDialogVisible: false,
      targetRow: null,
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    getMgmList() {
      rejecthttp(
        true,
        "get",
        "/manage/mgm/list",
        {
          appid: 188,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.mgmList = doc.data.data;
            this.mgmList.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
              if (any.fromdate != null) {
                any.fromdate = commonUtil.formatDate(any.fromdate);
              } else {
                any.fromdate = "无限制";
              }
              if (any.todate != null) {
                any.todate = commonUtil.formatDate(any.todate);
              } else {
                any.todate = "无限制";
              }
            });
          }
        }
      );
    },

    refreshRank() {
      rejecthttp(
        true,
        "get",
        "/manage/mgm/rank",
        { appid: "188", mgmid: this.mgmID },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log("aaaaaaaaaaaaaaaaa",doc.data);
            // 添加总条数
            this.rankList = doc.data.data
            console.log("bbbbbbbbbbbbbbbb", this.rankList);
          }
        }
      );
    },

    refresh() {
        this.getMgmList();
    },

    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}

.serachSpan {
  width: 7%;
}
.serachText {
  width: 13%;
}
.serachInput {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/mgmrank.vue